// main.js
import { createApp } from 'vue'
import { srCyrl, srLatn, en } from 'vuetify/locale'
import App from './App.vue'
import money from '@/directives/money'
import router from './router'
import store from "./store"
//import { createI18n } from 'vue-i18n'
//import messages from './locales'
//import sr from './locales/sr.json'
//import bs from './locales/bs.json'

import i18n from './locales'

import axios from 'axios'

window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  locale: {
     locale: localStorage.getItem('lang') || 'bs',
    fallback: 'bs',
    messages: { bs: srLatn, sr: srCyrl, en: en,  'cir-ekavica': srCyrl,  'lat-ekavica': srLatn},
    adapter: {
      t: (key, ...params) => i18n.global.t(key, params)
    }
  }
})


// ✅ BootstrapVue 3
import { createBootstrap, BTable, BPagination, BButton, BForm, BFormGroup, BFormInput, BFormSelect, BInputGroup, BOverlay, BModal } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import '@mdi/font/css/materialdesignicons.css'

// ✅ SweetAlert2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

// ✅ Webfont loader za Vuetify
import { loadFonts } from './plugins/webfontloader'

// ✅ Ostali globalni stilovi
import './assets/styles/global.css'

// ✅ Leaflet CSS
import 'leaflet/dist/leaflet.css'

// ✅ Service worker ako koristis PWA
import './registerServiceWorker'


const app = createApp(App)
app.directive('money', money)

// global axios
app.config.globalProperties.$axios = axios

// hostname
import { hostname } from './config'
app.config.globalProperties.$hostname = hostname

app.config.globalProperties.$ValueSocket = true

axios.defaults.baseURL = app.config.globalProperties.$hostname + "api/"
axios.defaults.withCredentials = false

// custom HEADER
axios.interceptors.request.use(
  (config) => {
    if (!config.url.includes('Authentication')) {
      const token = localStorage.getItem("Token");
      if (token) config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    localStorage.clear();
    localStorage.setItem('TokenCheck', 0);
    return Promise.reject(error)
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 || error.response?.status === 401) {
      store.dispatch("NOTIF_LOGOUT", {
        poruka: i18n.global.t('session.expired'),
        position: "center",
        icon: "error",
        timer: 3500,
        width: "550"
      })
    }
    return Promise.reject(error)
  }
);

// 🌐 Install plugins
app.use(i18n)
app.use(router)
app.use(store)
app.use(vuetify)
app.use(createBootstrap())
app.use(VueSweetalert2)

// 🌐 Register global BootstrapVue components
app.component('BTable', BTable)
app.component('BPagination', BPagination)
app.component('BButton', BButton)
app.component('BForm', BForm)
app.component('BFormGroup', BFormGroup)
app.component('BFormInput', BFormInput)
app.component('BFormSelect', BFormSelect)
app.component('BInputGroup', BInputGroup)
app.component('BOverlay', BOverlay)
app.component('BModal', BModal)

// 🌐 Load fonts for Vuetify
loadFonts()

// Mount app
app.mount('#app')
